module.exports = __webpack_public_path__ + "static/media/bs_site-home.cad19a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/bs_site-home.png
// module id = 71
// module chunks = 0